<template>
    <div class="my-swipe">
        <!-- 管理数据看板-->
        <div class="my-swipe-item">
            <!--快速总览-->
            <div class="plate-common speed-plat">
                <div class="title-wrap">
                    <div class="title">
                        <img src="@/assets/images/track/title-icon.png" alt="">
                        <span>快速总览</span>
                    </div>
                    <div class="time-wrap" @click="openTimeSelect(0)">
                        <span>{{objSell.speedPlatTime[0]}}~{{objSell.speedPlatTime[1]}}</span>
                        <img src="@/assets/images/track/time-icon.png" alt="">
                    </div>
                </div>
                <div class="plat-data">
                    <template v-for="item in objSell.speedPlat">
                        <div class="plat-data-item">
                            <div class="num">{{ item.num }}</div>
                            <div class="name">{{ item.name }}</div>
                        </div>
                    </template>
                </div>
            </div>
            <!--客户行为-->
            <div class="plate-common customer-plat">
                <div class="title-wrap">
                    <div class="title">
                        <img src="@/assets/images/track/title-icon.png" alt="">
                        <span>客户行为</span>
                        <div class="order-wrap" @click="formOpenClose('PM')">
                            <span>排序</span>
                            <img src="@/assets/images/track/ci.png" alt="">
                            <div class="option-wrap option-wrap-center" @click.stop v-show="objCustomerEva.formOneOptionIsOrder">
                                <template v-for="(item,index) in objCustomerEva.formOneOptionArrOrder">
                                    <div class="option-item" :style="{'color':!item.active?'#A1A1A1':'#318544'}" @click="changeFormOneOption('PM',index)">{{item.name}}</div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="time-wrap" @click="openTimeSelect('BEHAVIOR')">
                        <span>{{objSell.customerPlatTime[0]}}~{{objSell.customerPlatTime[1]}}</span>
                        <img src="@/assets/images/track/time-icon.png" alt="">
                    </div>
                </div>
                <van-swipe class="my-swipe-map"  ref="cusSwiperRef" autoplay="false" :show-indicators="false" :touchable="false">
                    <van-swipe-item class="van-swipe-item van-swipe-item-one">
                        <div class="form-tab-wrap">
                            <div class="fixed-left">
                                <div class="form-title">
                                    <span>触达时间</span>
                                </div>
                                <div class="form-title">
                                    <span>姓名</span>
                                </div>
                            </div>
                            <div class="scroll-right" @touchstart="touchStartCusRightOne"
                                 @touchmove="touchMoveCusRightOne" @touchend="touchEndCusRightOne" :style="{'transform':`translateX(${objCustomerEva.formOneScrollZhenWidth}px)`}">
                                <div class="form-title">转发板块</div>
                                <div class="form-title">查看时长</div>
                                <div class="form-title">是否成交</div>
                            </div>
                        </div>
                        <div class="form-content" ref="formContentCus">
                            <div class="fixed-left" ref="mapFormLeft">
                                <template v-for="(item,index) in objCustomerEva.formOneData">
                                    <div class="fixed-item-left"
                                         :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}" >
                                        <div class="form-title">{{item.created_at}}</div>
                                        <div class="form-title">{{item.nickname}}</div>
                                    </div>
                                </template>
                            </div>
                            <div class="scroll-right" @touchstart="touchStartCusRightOne"
                                 @touchmove="touchMoveCusRightOne" @touchend="touchEndCusRightOne">
                                <template v-for="(item,index) in objCustomerEva.formOneData">
                                    <div class="fixed-item-right" :style="{'transform':`translateX(${objCustomerEva.formOneScrollZhenWidth}px)`}">
                                        <div class="form-title" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}">{{item.channel_name || '未查询到'}}</div>
                                        <div class="form-title" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6'),color:'#008C2F'}">{{item.visit_time}}</div>
                                        <div class="form-title" :class="{'form-title-active':item.is_buy}" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}">
                                            <div class="form-title-flex" @click="openisShowRemarks(item)">
                                                <span>{{item.is_buy?'是':'否'}}</span>
                                                <img v-if="!item.is_buy" class="edit-img" src="@/assets/images/track/edit.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div v-if="false" class="page-wrap">
                                <div class="prev" @click="prevPage('CUSTORM_BRHARIVE')">
                                    <img src="@/assets/images/case/map/prev.png" alt="">
                                </div>
                                <template v-for="(item,index) in parseInt((objCustomerEva.nTotal-1)/10)+1">
                                    <div class="num-page" @click="changeCurrent('CUSTORM_BRHARIVE',index)" :class="{'num-page-active':index==objCustomerEva.nPage}">{{index+1}}</div>
                                </template>
                                <div class="prev" @click="nextPage('CUSTORM_BRHARIVE',parseInt((objCustomerEva.nTotal-1)/10))">
                                    <img src="@/assets/images/case/map/next.png" alt="">
                                </div>
                            </div>
                            <div class="tips-other" v-if="objCustomerEva.isShowTips">{{objCustomerEva.nShowTipsType==0?'暂无更多数据':'加载中▪▪▪'}}</div>
                        </div>
                        <div class="vant-pagination-wrap">
                            <van-pagination v-model="objCustomerEva.currentPage" :total-items="objCustomerEva.nTotal" :show-page-size="7" force-ellipses @change="vantPageChange($event,'CUSTORM_BRHARIVE')">
                                <template #prev-text>
                                    <van-icon name="arrow-left" />
                                </template>
                                <template #next-text>
                                    <van-icon name="arrow" />
                                </template>
                                <template #page="{ text }">{{ text }}</template>
                            </van-pagination>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <!--分品类内容榜单-->
            <div class="plate-common category-plat">
                <div class="title-wrap">
                    <div class="title">
                        <img src="@/assets/images/track/title-icon.png" alt="">
                        <span>分品类内容榜单</span>
                        <div class="order-wrap"  v-show="objCategoryVae.nCurrentForm==1" @click="openOption">
                            <span>{{objCategoryVae.cascaderValue?objCategoryVae.nCityName:'城市'}}</span>
                            <img src="@/assets/images/track/ci.png" alt="">
                        </div>
                    </div>
                    <div class="time-wrap" @click="openTimeSelect('CATEGORY')">
                        <span>{{objSell.categoryTime[0]}}~{{objSell.categoryTime[1]}}</span>
                        <img src="@/assets/images/track/time-icon.png" alt="">
                    </div>
                </div>
                <div class="center-tips">
                    <div class="one-wrap" v-show="objCategoryVae.nCurrentForm==0">
                        <div class="option-wrap">
                            <!--关闭排序-->
                            <div class="order" v-show="false" @click="formOcCategoryOne('PM')">
                                <span>排序</span>
                                <img src="@/assets/images/track/ci.png" alt="">
                                <div class="option-wrap-order option-wrap-left" @click.stop v-show="objCategoryVae.formOneOptionIsOrder">
                                    <template v-for="(item,index) in objCategoryVae.formOneOptionArrOrder">
                                        <div class="option-item" :style="{'color':!item.active?'#A1A1A1':'#318544'}" @click="changeFormOneCategory('PM',index)">{{item.name}}</div>
                                    </template>
                                </div>
                            </div>
                            <div class="tips">各品类内容成交率TOP1</div>
                        </div>
                    </div>
                    <div class="two-wrap" v-show="objCategoryVae.nCurrentForm==1">
                        <div class="option-wrap">
                            <div class="order" @click="formOcCategoryOne('PM',2)">
                                <span>排序</span>
                                <img src="@/assets/images/track/ci.png" alt="">
                                <div class="option-wrap-order option-wrap-left" @click.stop v-show="objCategoryVae.formTwoOptionIsOrder">
                                    <template v-for="(item,index) in objCategoryVae.formTwoOptionArrOrder">
                                        <div class="option-item" :style="{'color':!item.active?'#A1A1A1':'#318544'}" @click="changeFormOneCategory('PM',index,2)">{{item.name}}</div>
                                    </template>
                                </div>
                            </div>
                            <div class="tips">电热水器内容榜单</div>
                        </div>
                        <div class="btn-wrap" @click="changeSwiperCurrent('CATECORY',0)">点击返回</div>
                    </div>
                </div>
                <van-swipe class="my-swipe-map" ref="cateSwiperRef" autoplay="false" :show-indicators="false" :touchable="false">
                    <van-swipe-item class="van-swipe-item van-swipe-item-one">
                        <div class="form-tab-wrap">
                            <div class="fixed-left">
                                <div class="form-title">
                                    <span>品类</span>
                                </div>
                                <div class="form-title">
                                    <span>内容</span>
                                </div>
                            </div>
                            <div class="scroll-right" >
                                <div class="form-title">触达用户数</div>
                                <div class="form-title">成交量</div>
                            </div>
                        </div>
                        <div class="form-content">
                            <div class="fixed-left" ref="mapFormLeft">
                                <template v-for="(item,index) in objCategoryVae.formOneData">
                                    <div class="fixed-item-left" @click="changeSwiperCurrent('CATECORY',1,item)"
                                         :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}" >
                                        <div class="form-title">{{item.name}}</div>
                                        <div class="form-title">{{item.title}}</div>
                                    </div>
                                </template>
                            </div>
                            <div class="scroll-right" ref="mapFormRight">
                                <template v-for="(item,index) in objCategoryVae.formOneData">
                                    <div class="fixed-item-right" @click="changeSwiperCurrent('CATECORY',1,item)">
                                        <div class="form-title" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}">{{item.reach_num}}</div>
                                        <div class="form-title" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}">{{item.deal_num}}</div>
                                    </div>
                                </template>
                            </div>
                            <div class="tips-other" >{{objCategoryVae.isShowTips?'暂无更多数据':'加载中▪▪▪'}}</div>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item v-show="objCategoryVae.isShowTwoForm" class="van-swipe-item van-swipe-item-two">
                        <div class="form-tab-wrap">
                            <div class="fixed-left">
                                <div class="form-title">
                                    <span>排名</span>
                                </div>
                                <div class="form-title">
                                    <span>内容</span>
                                </div>
                            </div>
                            <div class="scroll-right" >
                                <div class="form-title">触达数用户</div>
                                <div class="form-title">转发量</div>
                            </div>
                        </div>
                        <div class="form-content" @click="toXcx(objCategoryVae.formTwoData)">
                            <div class="fixed-left" ref="mapFormLeft">
                                <template v-for="(item,index) in objCategoryVae.formTwoData">
                                    <div class="fixed-item-left"
                                         :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}" >
                                        <div class="form-title">{{index+1}}</div>
                                        <div class="form-title">{{item.title}}</div>
                                    </div>
                                </template>
                            </div>
                            <div class="scroll-right" ref="mapFormRight">
                                <template v-for="(item,index) in objCategoryVae.formTwoData">
                                    <div class="fixed-item-right">
                                        <div class="form-title" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}">{{item.reach_num}}</div>
                                        <div class="form-title" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}">{{item.share_num}}</div>
                                    </div>
                                </template>
                            </div>
                            <div class="tips-other" v-if="objCategoryVae.isShowTipsTwo">{{objCategoryVae.nShowTipsTypeTwo==0?'暂无更多数据':'加载中▪▪▪'}}</div>
                            <div class="page-wrap" v-if="false">
                                <div class="prev" @click="prevPage('CATEGORY_TWO')">
                                    <img src="@/assets/images/case/map/prev.png" alt="">
                                </div>
                                <template v-for="(item,index) in parseInt((objCategoryVae.nTotalTwo-1)/10)+1">
                                    <div class="num-page" @click="changeCurrent('CATEGORY_TWO',index)" :class="{'num-page-active':index==objCategoryVae.nPageTwo}">{{index+1}}</div>
                                </template>
                                <div class="prev" @click="nextPage('CATEGORY_TWO',parseInt((objCategoryVae.nTotalTwo-1)/10))">
                                    <img src="@/assets/images/case/map/next.png" alt="">
                                </div>
                            </div>
<!--                            <div v-show="objCategoryVae.formTwoData.length>0">-->
<!--                                <wx-open-launch-weapp-->
<!--                                    class="a-link"-->
<!--                                    id="launch-btn"-->
<!--                                    appid="wx240dab08ef10955e"-->
<!--                                    username="gh_633412ba32dd"-->
<!--                                    path="pages/lectotype/house/index"-->
<!--                                >-->
<!--                                    <script type="text/wxtag-template">-->
<!--                                        <div class="btn-xcx" style="position: absolute;width: 100%;height: 100%;top: 0;left: 0;z-index: 99"></div>-->
<!--                                    </script>-->
<!--                                </wx-open-launch-weapp>-->
<!--                            </div>-->
                        </div>
                        <div class="vant-pagination-wrap">
                            <van-pagination v-model="objCategoryVae.currentPageTwo" :total-items="objCategoryVae.nTotalTwo" :show-page-size="7" force-ellipses @change="vantPageChange($event,'CATEGORY_TWO')">
                                <template #prev-text>
                                    <van-icon name="arrow-left" />
                                </template>
                                <template #next-text>
                                    <van-icon name="arrow" />
                                </template>
                                <template #page="{ text }">{{ text }}</template>
                            </van-pagination>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <!--智慧集成系统口碑数据-->
            <div class="plate-common customer-plat">
                <div class="title-wrap">
                    <div class="title">
                        <img src="@/assets/images/track/title-icon.png" alt="">
                        <span>智慧集成系统口碑数据</span>
                    </div>
                    <div class="time-wrap" @click="openTimeSelect('WISDOM')">
                        <span>{{objSell.arrMapCaseTime[0]}}~{{objSell.arrMapCaseTime[1]}}</span>
                        <img src="@/assets/images/track/time-icon.png" alt="">
                    </div>
                </div>
                <div class="case-data-wrap">
                    <!-- 交付书-->
                    <div class="case-data-item">
                        <div class="title-wrap">
                            <div class="title">
                                <span>艾暖通交付书数据</span>
                            </div>
                        </div>
                        <div class="module-wrap">
                            <template v-for="item in objSell.arrMapCase">
                                <div class="module-item">
                                    <div class="module-num">{{ item.num }}</div>
                                    <div class="module-name">{{ item.name }}</div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!-- 口碑-->
                    <div class="case-data-item">
                        <div class="title-wrap">
                            <div class="title">
                                <span>口碑运营数据</span>
                            </div>
                        </div>
                        <div class="module-wrap">
                            <template v-for="item in objSell.arrMapMedium">
                                <div class="module-item">
                                    <div class="module-num">{{ item.num }}</div>
                                    <div class="module-name">{{ item.name }}</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--日期区间组件-->
        <van-calendar v-model:show="isShowCale" :min-date="minDate" :default-date="defaultDate" :max-date="maxDate" color="#00883B" :allow-same-day="true" type="range" @confirm="onConfirmCale" />
        <!--    省份,城市联动级联-->
        <van-popup v-model="objSell.isShowCascader" round position="bottom">
            <van-cascader
                v-model="objCategoryVae.cascaderValue"
                title="请选择所在城市"
                :field-names="{ text: 'name', value: 'id', children: 'self_next' }"
                :options="objSell.regionProviceCityArr"
                @close="objCategoryVae.isShowCascader = false"
                @finish="onFinishCascader"
            />
        </van-popup>
        <!--备注弹框-->
        <div class="popup-wrap" v-show="isShowRemarks">
            <div class="popup-content">
                <div class="title">备注</div>
                <div class="text-area">
                    <textarea placeholder="请输入备注!" v-model="sRemarks"></textarea>
                </div>
                <div class="btn">
                    <div class="btn-item" @click="isShowRemarks=false">取消</div>
                    <div class="btn-item" @click="okEditRemarks">确定</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import oTrack from "@/js/track/indexv2";
import {getWxSingleConfig} from "@/js/wx.js";
import { getQrcodeUrl } from "@/js/member/mynews/index.js";
import Team from "@/page/project/detail/team/team";
export default {
    components: {Team},
    data() {
        return {
            toXcxPath:'',
            isShowRemarks:false,//是否显示备注
            sRemarks:'',//备注内容
            CalendarType:0,//打开的日历模块
            defaultDate:[],//默认打开日历时间区间
            sCurrentDayStart:'',//现实生活的当前月份第一天
            sCurrentDayEnd:'',//现实生活的当前月份的当天
            minDate: new Date(1990, 1, 1),//日期范围
            maxDate: new Date(),//日期范围
            isShowCale:false,//日期组件
            objReMarkItem:{},
            // 管理数据看板
            objSell: {
                regionProviceCityArr:[],
                isShowCascader:false,
                speedPlatTime:[],//快速预览时间区间
                speedPlat: [
                    // {name: "使用人数", num: ''},
                    {name: "转发量", num: '',key:'shares'},
                    {name: "触达用户数", num: '',key:'reach'},
                    {name: "客户浏览量", num: '',key:'views'},
                    {name: "成交量", num: '',key:'order'},
                    {name: "成交金额", num: '',key:'money'},
                    {name: "AI-LiNK多媒体数字展厅在线时长", num: '',key:'visit'},
                ],//快速预览
                arrMapCase:[
                    {name: "已/待分享", num: '',key:'shared'},
                    {name: "有效交付", num: '',key:'reach'},
                    {name: "累积激励", num: '',key:'motivate'},
                    {name: "评价项目数", num: '',key:'discuss'},
                    {name: "获得水暖毯", num: '',key:'rug'},
                ],//智慧集成系统口碑数据==交付书数据
                arrMapMedium:[
                    {name: "转发量", num: '',key:'shares'},
                    {name: "阅读量", num: '',key:'views'},
                    {name: "城市总转发量", num: '',key:'city_shares'},
                    {name: "城市总阅读量", num: '',key:'city_views'},
                ],//智慧集成系统口碑数据==口碑数据
                speedDqOption:[], // 快速总览大区下拉
                speedProviceOption:[],// 快速总览省份下拉
                speedCityOption:[],// 快速总览城市下拉
                customerPlatTime:[],//客户行为时间区间
                arrMapCaseTime:[],//智慧集成系统口碑数据-时间区间
                categoryTime:[],//分品类时间区间
            },
            //客户行为的基本使用变量customer
            objCustomerEva:{
                isShowTips:true,
                nShowTipsType:1,//1-加载中,0无更多数据
                currentPage:1,
                nPage:0,
                nTotal:0,
                formOneData:[],
                isYMove:0,//垂直滚动的距离
                nCurrentForm:0,//客户行为表的索引
                formOneStartX:'',//客户行为第一种表横向移动开始的位置
                formOneEndX:0,//客户行为第一种表横向移动结束的位置
                formOneMoveFlag:true,//客户行为第一种表判断是否在滑动
                formOneScrollWidth:0,
                formOneScrollZhenWidth:0,//客户行为第一种表横向滚动距离
                formOneOptionIsDq:false,//客户行为第一张表格大区下拉选项是否显示
                formOneOptionArrDq:[
                    {name:'大区',active:false},
                    {name:'省份',active:false},
                    {name:'城市',active:true},
                ],//客户行为第一张表格大区下拉选项
                formOneOptionIsOrder:false,//客户行为第一张表格顺序下拉选项是否显示
                formOneOptionArrOrder:[
                    {name:'查看时长从高到低',active:true,key:1},
                    {name:'查看时长从低到高',active:false,key:2},
                    {name:'触达时间顺序',active:false,key:3},
                    {name:'触达时间倒序',active:false,key:4},
                ],//客户行为第一张表格排序下拉选项
                formOneOptionIsRate:false,//客户行为第一张表格顺序下拉选项是否显示
                formOneOptionArrRate:[
                    {name:'成交率',active:true},
                    {name:'年成交率',active:false},
                ],//客户行为第一张表格成交率下拉选项
                formTwoOptionIsOrder:false,//客户行为第二张表格顺序下拉选项是否显示
                formTwoOptionArrOrder:[
                    {name:'顺序',active:true},
                    {name:'倒序',active:false},
                ],//客户行为第二张表格排序下拉选项
                formTwoOptionIsRate:false,//客户行为第二张表格顺序下拉选项是否显示
                formTwoOptionArrRate:[
                    {name:'成交率',active:true},
                    {name:'年成交率',active:false},
                ],//客户行为第二张表格成交率下拉选项
            },
            // 分品类的基本使用变量
            objCategoryVae:{
                isShowTips:true,
                isShowTipsTwo:true,
                nShowTipsTypeTwo:1,//1-加载中,0无更多数据
                currentPageTwo:1,
                nTotal:0,
                nPage:0,
                nTotalTwo:0,
                nPageTwo:0,
                nCateInfoId:0,//品类详情id
                cascaderValue:'',//城市id
                nCityName:'',
                formOneData:[],
                formTwoData:[],
                isShowTwoForm:false,
                nCurrentForm:0,//分品类表的索引
                formOneStartX:'',//分品类第一种表横向移动开始的位置
                formOneEndX:0,//分品类第一种表横向移动结束的位置
                formOneMoveFlag:true,//分品类第一种表判断是否在滑动
                formOneScrollWidth:0,
                formOneScrollZhenWidth:0,//分品类第一种表横向滚动距离
                formOneOptionIsDq:false,//分品类第一张表格大区下拉选项是否显示
                formOneOptionArrDq:[
                    {name:'大区',active:false},
                    {name:'省份',active:false},
                    {name:'城市',active:true},
                ],//产品中心第一张表格大区下拉选项
                formOneOptionIsOrder:false,//分品类第一张表格顺序下拉选项是否显示
                formOneOptionArrOrder:[
                    {name:'触达用户数从高到低',active:true,key:1},
                    {name:'触达用户数从低到高',active:false,key:2},
                    {name:'成交量从高到低',active:false,key:3},
                    {name:'成交量从低到高',active:false,key:4},
                ],//产品中心第一张表格排序下拉选项
                formOneOptionIsRate:false,//分品类第一张表格顺序下拉选项是否显示
                formOneOptionArrRate:[
                    {name:'成交率',active:true},
                    {name:'年成交率',active:false},
                ],//分品类第一张表格成交率下拉选项
                formTwoOptionIsOrder:false,//分品类第二张表格顺序下拉选项是否显示
                formTwoOptionArrOrder:[
                    {name:'触达用户数从高到低',active:false,key:1},
                    {name:'触达用户数从低到高',active:false,key:2},
                    {name:'转发量从高到低',active:true,key:3},
                    {name:'转发量从低到高',active:false,key:4},
                ],//分品类第二张表格排序下拉选项
                formTwoOptionIsRate:false,//分品类第二张表格顺序下拉选项是否显示
                formTwoOptionArrRate:[
                    {name:'成交率',active:true},
                    {name:'年成交率',active:false},
                ],//分品类第二张表格成交率下拉选项
            },
        }
    },
    created() {
        // 获取当前月首日以及当天日期
        this.sCurrentDayStart=this.getYMD().nowDateStart
        this.sCurrentDayEnd=this.getYMD().nowDateEnd
        // 各模块日期区间使用当前月
        let timeStartEnd = [this.sCurrentDayStart, this.sCurrentDayEnd]
        this.objSell.speedPlatTime= timeStartEnd
        this.objSell.customerPlatTime= timeStartEnd
        this.objSell.arrMapCaseTime= timeStartEnd
        this.objSell.categoryTime= timeStartEnd
        // 使用模块id请求模块快速总览数据
        this.$store.commit('loadSwitch',true)
        Promise.all([  this.getSingle(0,'first'),this.getUserBehavior('first')]).then(res=>{
            // this.getSingle(0)
            // 获取用户行为数据
            // this.getUserBehavior()
            // 直销员智慧集成口碑数据
            this.getWisdomMap()
            // 分品类榜单
            this.getCategory()
            this.getConfig()
        })
    },
    mounted() {
        var btn = document.getElementById('launch-btn');
        btn.addEventListener('launch', function (e) {
            console.log('success');
        });
        btn.addEventListener('error', function (e) {
            console.log('fail', e.detail);
        });
    },
    methods: {
        // 分品类跳转小程序
        toXcx(list){
            if(list.length>0){
                let path = list[0].page_url
                let a = path.split('?')[0]
                let b = path.split('?')[1]
                // let bArr  = b.split('&')
                // let obj = {}
                // bArr.forEach(it=>{
                //     obj[it.split('=')[0]]=it.split('=')[1]
                // })
                let data = {
                    page:a,
                    param:  b ,
                    type:3,
                }
                this.$store.commit("loadSwitch", true);
                getQrcodeUrl(data).then(res=>{
                    let qrcodeUrl = res.data.data.result.url;
                    console.log(qrcodeUrl)
                    window.location.href = qrcodeUrl;
                    this.$store.commit("loadSwitch", false);
                })
            }
        },
        // 确定修改
        okEditRemarks(){
            this.$store.commit('loadSwitch',true)
            oTrack.dealPost({
                remark:this.sRemarks,
                user_id:this.objReMarkItem.user_id,
                ymd:this.objReMarkItem.created_at
            }).then(res=>{
                this.$toast('修改成功!')
                this.isShowRemarks=false
                this.getUserBehavior()
                this.$store.commit('loadSwitch',false)
            }).catch(err=>{
                this.$toast('修改失败!')
                this.$store.commit('loadSwitch',false)
            })
        },
        // 打开备注
        openisShowRemarks(item){
            if(!item.is_buy){
                this.objReMarkItem=item
                this.sRemarks=item.remark
                this.isShowRemarks=true
            }
        },
        // vant分页点击改变
        vantPageChange(page,type){
            if(type=='CUSTORM_BRHARIVE'){
                this.objCustomerEva.nPage=page-1
                this.getUserBehavior()
            }else if(type=='CATEGORY_TWO'){
                // 分品类详情表
                this.objCategoryVae.nPageTwo=page-1
                this.getCategoryInfo(this.objCategoryVae.nCateInfoId)
            }
        },
        // 打开城市级联
        openOption(){
            this.objSell.isShowCascader=true
        },
        // 级联选择器
        onFinishCascader(e){
            this.objCategoryVae.nCityName=e.selectedOptions[1].name
            this.objSell.isShowCascader=false
            this.objCategoryVae.nPageTwo=0
            this.objCategoryVae.currentPageTwo=1
            this.getCategoryInfo(this.objCategoryVae.nCateInfoId)
        },
        //大区,省份筛选配置
        getConfig(){
            oTrack.config().then(res=>{
                let result = res.data.data.result
                this.objSell.regionProviceCityArr=result.district.map(item=>{
                    item.name=item.region_name
                    item.self_next.forEach(it=>{
                        it.self_next.forEach(i=>{
                            delete  i.self_next
                        })
                    })
                    return item
                })
            })
        },
        // 分页点击
        changeCurrent(type,index){
            if(type=='CUSTORM_BRHARIVE'){
                // 口碑地图第一张表
                this.objCustomerEva.nPage=index
                this.getUserBehavior()
            }else if(type=='CATEGORY_TWO'){
                // 分品类详情表
                this.objCategoryVae.nPageTwo=index
                this.getCategoryInfo(this.objCategoryVae.nCateInfoId)
            }
        },
        // 下一页
        nextPage(type,page){
            if(type=='CUSTORM_BRHARIVE'){
                // 口碑地图第一张表
                if(this.objCustomerEva.nPage==page)return
                this.objCustomerEva.nPage++
                this.getUserBehavior()
            }else if(type=='CATEGORY_TWO'){
                // 分品类详情表
                if(this.objCategoryVae.nPageTwo==page)return
                this.objCategoryVae.nPageTwo++
                this.getCategoryInfo(this.objCategoryVae.nCateInfoId)
            }
        },
        // 上一页
        prevPage(type){
            if(type=='CUSTORM_BRHARIVE'){
                // 口碑地图第一张表
                if(this.objCustomerEva.nPage==0)return
                this.objCustomerEva.nPage--
                this.getUserBehavior()
            }else if(type=='CATEGORY_TWO'){
                // 分品类详情表
                if(this.objCategoryVae.nPageTwo==0)return
                this.objCategoryVae.nPageTwo--
                this.getCategoryInfo(this.objCategoryVae.nCateInfoId)
            }
        },
        // 获取分品类榜单详情
        getCategoryInfo(id,sClose){
            this.objCategoryVae.nShowTipsTypeTwo=1
            this.$store.commit('loadSwitch',true)
            let orderArr = this.objCategoryVae.formTwoOptionArrOrder.filter(it=>{
                return it.active
            })
            let order=orderArr[0].key
            return new Promise((resolve, reject)=>{
                oTrack.categoryInfo({
                    id,
                    city:this.objCategoryVae.cascaderValue,
                    order,
                    start_time:this.objSell.categoryTime[0],
                    end_time:this.objSell.categoryTime[1],
                    page: this.objCategoryVae.nPageTwo,
                    limit:10,
                }).then(res=>{
                    console.log(res,'resolve')
                    let result = res.data.data.result
                    this.objCategoryVae.nTotalTwo=result.total
                    if(result.list){
                        this.objCategoryVae.formTwoData=result.list.map(item=>{
                            for (const itKey in item) {
                                if(this.isNumber(item[itKey])){
                                    item[itKey]=this.addSymbol(item[itKey])
                                }
                            }
                            return item
                        })
                    }
                    if(this.objCategoryVae.formTwoData.length>0){
                        this.toXcxPath=this.objCategoryVae.formTwoData[0].page_url
                    }
                    if(this.objCategoryVae.formTwoData.length<10){
                        // 长度小于limit说明无更多数据,展示无更多数据
                        this.objCategoryVae.isShowTipsTwo=true
                        this.objCategoryVae.nShowTipsTypeTwo=0
                    }else if(this.objCategoryVae.formTwoData.length==10){
                        // 长度大于limit需要判断是否是最后一页,是的话需要展示无更多数据
                        if( this.objCategoryVae.nPageTwo==parseInt((this.objCategoryVae.nTotalTwo-1)/10)){
                            this.objCategoryVae.isShowTipsTwo=true
                            this.objCategoryVae.nShowTipsTypeTwo=0
                        }else{
                            this.objCategoryVae.isShowTipsTwo=false
                        }
                    }
                    resolve(true)
                    if(sClose)return
                    this.$store.commit('loadSwitch',false)
                })
            })

        },
        // 分品类榜单
        getCategory(sClose){
            this.objCategoryVae.isShowTips=false
            this.$store.commit('loadSwitch',true)
            let orderArr = this.objCategoryVae.formOneOptionArrOrder.filter(it=>{
                return it.active
            })
            let order=orderArr[0].key
            return new Promise((resolve, reject)=>{
                oTrack.category({order,start_time:this.objSell.categoryTime[0],end_time:this.objSell.categoryTime[1]}).then(res=>{
                    let result = res.data.data.result
                    this.objCategoryVae.isShowTips=true
                    this.objCategoryVae.formOneData=result.map(item=>{
                        for (const itKey in item) {
                            if(this.isNumber(item[itKey])){
                                item[itKey]=this.addSymbol(item[itKey])
                            }
                        }
                        return item
                    })
                    resolve(true)
                    if(sClose)return
                    this.$store.commit('loadSwitch',false)
                })
            })

        },
        // 直销员智慧集成口碑数据
        getWisdomMap(){
            oTrack.wisdomMap({start_time:this.objSell.arrMapCaseTime[0],end_time:this.objSell.arrMapCaseTime[1]}).then(res=>{
                let result = res.data.data.result
                // 交付
                this.objSell.arrMapCase.forEach(it=>{
                    if(it.key!='shared'){
                        for (const itKey in result.delivery) {
                            if(it.key==itKey){
                                if(this.isNumber(result.delivery[itKey])){
                                    it.num=this.addSymbol(result.delivery[itKey])
                                }else{
                                    it.num=result.delivery[itKey]
                                }
                            }
                        }
                    }else{
                        it.num=`${result.delivery?.shared}/${result.delivery?.share}`
                    }
                })
                // 口碑
                this.objSell.arrMapMedium.forEach(it=>{
                    for (const itKey in result.praise) {
                        if(it.key==itKey){
                            if(this.isNumber(result.praise[itKey])){
                                it.num=this.addSymbol(result.praise[itKey])
                            }else{
                                it.num=result.praise[itKey]
                            }
                        }
                    }
                })
                console.log(result)
            })
        },
        // 获取用户行为数据
        getUserBehavior(state){
            this.objCustomerEva.nShowTipsType=1
            this.$store.commit('loadSwitch',true)
            let orderArr = this.objCustomerEva.formOneOptionArrOrder.filter(it=>{
                return it.active
            })
            let order=orderArr[0].key
            return new Promise(resolve => {
                oTrack.userBehavior({page:this.objCustomerEva.nPage,limit:10,order,start_time:this.objSell.customerPlatTime[0],end_time:this.objSell.customerPlatTime[1]}).then(res=>{
                    let result = res.data.data.result
                    this.objCustomerEva.formOneData=result.list
                    this.objCustomerEva.nTotal=result.total
                    console.log(result,'客户行为')
                    if(this.objCustomerEva.formOneData.length<10){
                        // 长度小于limit说明无更多数据,展示无更多数据
                        this.objCustomerEva.isShowTips=true
                        this.objCustomerEva.nShowTipsType=0
                    }else if(this.objCustomerEva.formOneData.length==10){
                        // 长度大于limit需要判断是否是最后一页,是的话需要展示无更多数据
                        if( this.objCustomerEva.nPage==parseInt((this.objCustomerEva.nTotal-1)/10)){
                            this.objCustomerEva.isShowTips=true
                            this.objCustomerEva.nShowTipsType=0
                        }else{
                            this.objCustomerEva.isShowTips=false
                        }
                    }
                    if(!state){
                        this.$store.commit('loadSwitch',false)
                    }
                    resolve(true)
                })
            })

        },
        // 获取方格数据
        getSingle(id,state){
            this.$store.commit('loadSwitch',true)
            // 判断模块id拿不同的时间请求
            let start_time=''
            let end_time=''
            if(id==0){
                // 0=全平台总览
                start_time=this.objSell.speedPlatTime[0]
                end_time=this.objSell.speedPlatTime[1]
            }
            return new Promise(resolve => {
                oTrack.moudeleSingleDirect({id,start_time,end_time,type:3}).then(res=>{
                    let result = res.data.data.result
                    if(id==0){
                        // / 0=快速总览
                        this.objSell.speedPlat.forEach(it=>{
                            for (const itKey in result) {
                                if(it.key==itKey){
                                    if(this.isNumber(result[itKey])){
                                        it.num=this.addSymbol(result[itKey])
                                    }else{
                                        it.num=result[itKey]
                                    }
                                }
                            }
                        })
                    }
                    if(!state){
                        this.$store.commit('loadSwitch',false)
                    }
                    resolve(true)
                })
            })
        },
        /**
         * 校验只要是数字（包含正负整数，0以及正负浮点数）就返回true
         **/
        isNumber(val){
            var regPos = /^[0-9]+.?[0-9]*/; //判断是否是数字。
            if(regPos.test(val) ){
                return true;
            }else{
                return false;
            }
        },
        // 加千位符
        addSymbol(num){
            var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
                return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                    return $1+",";
                });
            })
            return res;
        },
        // 获取当前年月日
        getYMD(){
            let myDate = new Date()
            let myYear = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
            let myMonth = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
            let myToday = myDate.getDate(); //获取当前日(1-31)
            myMonth = myMonth > 9 ? myMonth : '0' + myMonth
            myToday = myToday > 9 ? myToday : '0' + myToday
            let nowDateStart = myYear + '-' +myMonth + '-' + '01'
            let nowDateEnd = myYear + '-' + myMonth + '-' + myToday
            return {nowDateStart,nowDateEnd}
        },
        // 中国标准时间转标准时间
        newDate(time) {
            var date = new Date(time)
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? '0' + m : m
            var d = date.getDate()
            d = d < 10 ? '0' + d : d
            return y + '-' + m + '-' + d
        },
        // 通过过滤展示不同的选项文字
        filterNameArr(arr){
            let arrFilter = arr.filter(it=>{
                return it.active
            })
            return arrFilter[0].name
        },
        // 轮播图切换
        changeSwiperCurrent(type,index,item){
            if(type=='CATECORY'){
                if(index==1){
                    // 获取详情
                    this.objCategoryVae.nCateInfoId=item.id
                    this.getCategoryInfo(item.id)
                    this.objCategoryVae.isShowTwoForm=true
                }else{
                    this.objCategoryVae.isShowTwoForm=false
                    this.objCategoryVae.nPageTwo=0
                    this.objCategoryVae.currentPageTwo=1
                }
                this.objCategoryVae.nCurrentForm=index
                this.$refs.cateSwiperRef.swipeTo(index)
            }
        },
        // 日期区间选择
        onConfirmCale(e){
            if(this.nCalendarType==0){
                // 全平台总览
                let timeArr=[this.newDate(e[0]),this.newDate(e[1])]
                this.objSell.speedPlatTime=timeArr
                this.getSingle(0)
            }else if(this.nCalendarType=='WISDOM'){
                // 智慧集成系统口碑数据
                let timeArr=[this.newDate(e[0]),this.newDate(e[1])]
                this.objSell.arrMapCaseTime=timeArr
                this.getWisdomMap()
            }else if(this.nCalendarType=='CATEGORY'){
                let timeArr=[this.newDate(e[0]),this.newDate(e[1])]
                this.objSell.categoryTime=timeArr
                this.objCategoryVae.nPageTwo=0
                this.objCategoryVae.currentPageTwo=1
                this.$store.commit('loadSwitch',true)
                Promise.all([this.getCategoryInfo(this.objCategoryVae.nCateInfoId,'close'),this.getCategory('close')]).then(res=>{
                    this.$store.commit('loadSwitch',false)
                })
            }else if(this.nCalendarType=='BEHAVIOR'){
                this.objCustomerEva.nPage=0
                this.objCustomerEva.currentPage=1
                let timeArr=[this.newDate(e[0]),this.newDate(e[1])]
                this.objSell.customerPlatTime=timeArr
                this.getUserBehavior()
            }
            this.isShowCale=false
        },
        // 打开日期选择弹框
        openTimeSelect(type){
            this.nCalendarType=type
            if(type==0){
                // 全平台快速总览
                let timeArr=[new Date(this.objSell.speedPlatTime[0]),new Date(this.objSell.speedPlatTime[1])]
                this.defaultDate=timeArr
            }else if(type=='WISDOM'){
                // 智慧集成系统口碑数据
                let timeArr=[new Date(this.objSell.arrMapCaseTime[0]),new Date(this.objSell.arrMapCaseTime[1])]
                this.defaultDate=timeArr
            }else if(type=='CATEGORY'){
                // 智慧案发布数据
                let timeArr=[new Date(this.objSell.categoryTime[0]),new Date(this.objSell.categoryTime[1])]
                this.defaultDate=timeArr
            }else if(type=='BEHAVIOR'){
                // 客户行为
                let timeArr=[new Date(this.objSell.customerPlatTime[0]),new Date(this.objSell.customerPlatTime[1])]
                this.defaultDate=timeArr
            }
            this.isShowCale=true
        },
        // 客户行为数据第一种表格按下事件
        touchStartCusRightOne(e) {
            this.objCustomerEva.formOneStartX = e.touches[0].pageX // 开始触摸时的原点
            this.objCustomerEva.formOneMoveFlag = true
            this.objCustomerEva.isYMove=this.$refs.formContentCus.scrollTop
        },
        //客户行为数据第一种表格移动事件
        touchMoveCusRightOne(e) {
            let startX = e.touches[0].pageX
            if(this.$refs.formContentCus.scrollTop!= this.objCustomerEva.isYMove)return
            if (this.objCustomerEva.formOneMoveFlag) {
                if ( this.objCustomerEva.formOneEndX) {
                    this.objCustomerEva.formOneScrollWidth += (startX - this.objCustomerEva.formOneEndX);
                    if (this.objCustomerEva.formOneScrollWidth > 0) {
                        this.objCustomerEva.formOneScrollWidth = 0
                    } else if (this.objCustomerEva.formOneScrollWidth < (-145)) {
                        this.objCustomerEva.formOneScrollWidth = -145
                    } else {
                        this.objCustomerEva.formOneScrollZhenWidth = JSON.parse(JSON.stringify(this.objCustomerEva.formOneScrollWidth));
                    }
                }
                this.objCustomerEva.formOneEndX = startX// 结束触摸时的原点
            }
        },
        // 客户行为数据第一种表格松开事件
        touchEndCusRightOne(e) {
            this.objCustomerEva.formOneMoveFlag = true;
            this.objCustomerEva.formOneEndX = 0;
        },
        // 客户行为数据表格的选项标题点击 index==第几张表
        formOpenClose(type,index){
            if(!index){
                if(type=='PM'){
                    this.objCustomerEva.formOneOptionIsOrder=!this.objCustomerEva.formOneOptionIsOrder
                    this.objCustomerEva.formOneOptionIsRate=false
                    this.objCustomerEva.formOneOptionIsDq=false
                }else if(type=='DQ'){
                    this.objCustomerEva.formOneOptionIsDq=!this.objCustomerEva.formOneOptionIsDq
                    this.objCustomerEva.formOneOptionIsRate=false
                    this.objCustomerEva.formOneOptionIsOrder=false
                }else if(type=='CJL'){
                    this.objCustomerEva.formOneOptionIsRate=!this.objCustomerEva.formOneOptionIsRate
                    this.objCustomerEva.formOneOptionIsOrder=false
                    this.objCustomerEva.formOneOptionIsDq=false
                }
            }else if(index==2){
                if(type=='PM'){
                    this.objCustomerEva.formTwoOptionIsOrder=!this.objCustomerEva.formTwoOptionIsOrder
                    this.objCustomerEva.formTwoOptionIsRate=false
                }else if(type=='CJL'){
                    this.objCustomerEva.formTwoOptionIsRate=!this.objCustomerEva.formTwoOptionIsRate
                    this.objCustomerEva.formTwoOptionIsOrder=false
                }
            }

        },
        // 客户行为数据第一个表格的下拉选项选择===current=第几张表
        changeFormOneOption(type,index,current){
            if(!current){
                this.objCustomerEva.nPage=0
                this.objCustomerEva.currentPage=1
                if(type=='PM'){
                    this.objCustomerEva.formOneOptionArrOrder.forEach((item,itx)=>{
                        index==itx?item.active=true: item.active=false
                    })
                    this.objCustomerEva.formOneOptionIsOrder=false
                    this.getUserBehavior()
                }else if(type=='DQ'){
                    this.objCustomerEva.formOneOptionArrDq.forEach((item,itx)=>{
                        index==itx?item.active=true: item.active=false
                    })
                    this.objCustomerEva.formOneOptionIsDq=false
                }else if(type=='CJL'){
                    this.objCustomerEva.formOneOptionArrRate.forEach((item,itx)=>{
                        index==itx?item.active=true: item.active=false
                    })
                    this.objCustomerEva.formOneOptionIsRate=false
                }
            }else if(current==2){
                if(type=='PM'){
                    this.objCustomerEva.formTwoOptionArrOrder.forEach((item,itx)=>{
                        index==itx?item.active=true: item.active=false
                    })
                    this.objCustomerEva.formTwoOptionIsOrder=false
                }else if(type=='CJL'){
                    this.objCustomerEva.formTwoOptionArrRate.forEach((item,itx)=>{
                        index==itx?item.active=true: item.active=false
                    })
                    this.objCustomerEva.formTwoOptionIsRate=false
                }
            }

        },
        // 分品类第一种表格按下事件
        touchStartCategoryRightOne(e) {
            this.objCategoryVae.formOneStartX = e.touches[0].pageX // 开始触摸时的原点
            this.objCategoryVae.formOneMoveFlag = true
        },
        // 分品类第一种表格移动事件
        touchMoveCategoryRightOne(e) {
            let startX = e.touches[0].pageX
            if (this.objCategoryVae.formOneMoveFlag) {
                if ( this.objCategoryVae.formOneEndX) {
                    this.objCategoryVae.formOneScrollWidth += (startX - this.objCategoryVae.formOneEndX);
                    if (this.objCategoryVae.formOneScrollWidth > 0) {
                        this.objCategoryVae.formOneScrollWidth = 0
                    } else if (this.objCategoryVae.formOneScrollWidth < (-160)) {
                        this.objCategoryVae.formOneScrollWidth = -160
                    } else {
                        this.objCategoryVae.formOneScrollZhenWidth = JSON.parse(JSON.stringify(this.objCategoryVae.formOneScrollWidth));
                    }
                }
                this.objCategoryVae.formOneEndX = startX// 结束触摸时的原点
            }
        },
        //分品类第一种表格松开事件
        touchEndCategoryRightOne(e) {
            this.objCategoryVae.formOneMoveFlag = true;
            this.objCategoryVae.formOneEndX = 0;
        },
        // 分品类第一个表格的选项标题点击,current=第几张表
        formOcCategoryOne(type,current){
            if(!current){
                if(type=='PM'){
                    this.objCategoryVae.formOneOptionIsOrder=!this.objCategoryVae.formOneOptionIsOrder
                    this.objCategoryVae.formOneOptionIsRate=false
                    this.objCategoryVae.formOneOptionIsDq=false
                }else if(type=='DQ'){
                    this.objCategoryVae.formOneOptionIsDq=!this.objCategoryVae.formOneOptionIsDq
                    this.objCategoryVae.formOneOptionIsRate=false
                    this.objCategoryVae.formOneOptionIsOrder=false
                }else if(type=='CJL'){
                    this.objCategoryVae.formOneOptionIsRate=!this.objCategoryVae.formOneOptionIsRate
                    this.objCategoryVae.formOneOptionIsOrder=false
                    this.objCategoryVae.formOneOptionIsDq=false
                }
            }else if(current==2){

                if(type=='PM'){
                    this.objCategoryVae.formTwoOptionIsOrder=!this.objCategoryVae.formTwoOptionIsOrder
                    this.objCategoryVae.formOneOptionIsRate=false
                }else if(type=='CJL'){
                    this.objCategoryVae.formTwoOptionIsRate=!this.objCategoryVae.formTwoOptionIsRate
                    this.objCategoryVae.formTwoOptionIsOrder=false
                }
            }

        },
        // 分品类第一个表格的下拉选项选择current=第几张表
        changeFormOneCategory(type,index,current){
            if(!current){
                if(type=='PM'){
                    this.objCategoryVae.formOneOptionArrOrder.forEach((item,itx)=>{
                        index==itx?item.active=true: item.active=false
                    })
                    this.objCategoryVae.formOneOptionIsOrder=false
                    this.getCategory()
                }else if(type=='DQ'){
                    this.objCategoryVae.formOneOptionArrDq.forEach((item,itx)=>{
                        index==itx?item.active=true: item.active=false
                    })
                    this.objCategoryVae.formOneOptionIsDq=false
                }else if(type=='CJL'){
                    this.objCategoryVae.formOneOptionArrRate.forEach((item,itx)=>{
                        index==itx?item.active=true: item.active=false
                    })
                    this.objCategoryVae.formOneOptionIsRate=false
                }
            }else if(current==2){
                this.objCategoryVae.nPageTwo=0
                this.objCategoryVae.currentPageTwo=1
                if(type=='PM'){
                    this.objCategoryVae.formTwoOptionArrOrder.forEach((item,itx)=>{
                        index==itx?item.active=true: item.active=false
                    })
                    this.objCategoryVae.formTwoOptionIsOrder=false
                    this.getCategoryInfo(this.objCategoryVae.nCateInfoId)
                }else if(type=='CJL'){
                    this.objCategoryVae.formTwoOptionArrRate.forEach((item,itx)=>{
                        index==itx?item.active=true: item.active=false
                    })
                    this.objCategoryVae.formTwoOptionIsRate=false
                }
            }

        },
    },
}
</script>
<style>
.vant-pagination-wrap .van-pagination__item{
    min-width: 0.6rem;
    height: 0.746667rem;
    border-radius: 0.053333rem;
    border: 0.013333rem solid rgba(0, 0, 0, 0.08);
    font-size: 0.32rem;
    font-weight: 400;
    color: #525F66;
    margin: 0 0.106667rem;
}
.vant-pagination-wrap .van-pagination__item--active{
    color: #2B447E;
    border: 1px solid #008C2F;
    background: transparent;
}
</style>
<style lang="scss" scoped>
*{
    user-select: none!important;
}
::-webkit-scrollbar {
    display: none
}

.my-swipe {
    width: 100%;
    height: 100%;

    .my-swipe-item {
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: scroll;

        .plate-common {
            box-sizing: border-box;
            padding: 24px 16px 0 16px;
            border-bottom: 16px solid #F7F7F7;
            width: 100%;

            .title-wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;


                .title {
                    display: flex;
                    align-items: center;

                    img {
                        width: 14px;
                        height: 32px;
                        margin-right: 6px;
                    }

                    span {
                        font-size: 28px;
                        font-weight: 500;
                        color: #318544;
                        white-space: nowrap;
                    }
                }

                .time-wrap {
                    height: 56px;
                    display: flex;
                    align-items: center;
                    background: #F7F8F8;
                    border-radius: 12px;
                    padding: 0 12px;

                    span {
                        font-size: 22px;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.4);
                    }

                    img {
                        width: 32px;
                        margin-left: 16px;
                        height: 32px;
                    }
                }
                .order-wrap{
                    display: flex;
                    margin-left: 20px;
                    align-items: center;
                    position: relative;
                    span{
                        font-size: 24px;
                        font-weight: 400;
                        color: #9B9B9B;
                        margin-right: 4px;
                    }
                    img{
                        width: 20px;
                        margin: 0;
                        height: auto;
                    }
                    .option-wrap{
                        background: #FFFFFF;
                        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.07);
                        border-radius: 12px;
                        position: absolute;
                        top: 48px;
                        z-index: 13;
                        max-height: 440px;
                        overflow-x: hidden;
                        overflow-y: scroll;
                        .option-item{
                            white-space: nowrap;
                            font-size: 28px;
                            font-weight: 400;
                            color: #A1A1A1;
                            height: 80px;
                            padding:20px 45px;
                            position: relative;
                            &:after{
                                content:'';
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                                transform: translateX(-50%);
                                width: 60%;
                                height: 2px;
                                background:#F6F6F6;
                            }
                        }
                    }
                    .option-wrap-center{
                        left: 50% !important;
                        transform: translateX(-50%);
                    }
                    .option-wrap-left{
                        left: 0 !important;
                    }
                    .option-wrap-right{
                        right: 0 !important;
                    }
                }
            }
            .address-wrap{
                display: flex;
                align-items: center;
                .address-item{
                    display: flex;
                    align-items: center;
                    margin: 22px 12px 0 12px;
                    span{
                        font-size: 24px;
                        font-weight: 400;
                        color: #9B9B9B;
                    }
                    img{
                        width: 20px;
                        margin-left: 8px;
                    }
                }
            }

            .plat-data {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                margin-top: 28px;

                .plat-data-item {
                    width: 224px;
                    height: 180px;
                    background: rgba(53, 93, 75, 0.04);
                    border-radius: 16px;
                    margin-bottom: 12px;
                    display: flex;
                    flex-direction: column;
                    //justify-content: flex-end;
                    align-items: center;
                    padding: 0 5px;

                    .name {
                        font-size: 24px;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.3);
                        margin-bottom: 30px;
                        text-align: center;
                    }

                    .num {
                        font-size: 40px;
                        font-weight: 500;
                        color: #00883B;
                        margin-bottom: 20px;
                        margin-top: 34px;
                    }

                    &:last-child {
                        .num {
                            font-size: 35px;
                        }
                    }
                }
            }

            .my-swipe-map {
                margin: 24px 0;
                width: 100%;
                .van-swipe-item{
                    overflow: hidden;
                }

                .form-tab-wrap {
                    width: 100%;
                    height: 80px;
                    background: #008C2F;
                    border-radius: 16px 16px 0px 0px;
                    display: flex;
                    align-items: center;
                    font-size: 24px;
                    font-weight: 500;
                    color: #FFFFFF;
                    position: relative;
                    z-index: 15;

                    .fixed-left {
                        width: 236px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        z-index: 10;
                        background: #008C2F;

                        .form-title {
                            width: 50%;
                            text-align: center;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: relative;
                            .down-icon{
                                width: 28px;
                                margin-left: 3px;
                                margin-top: 2px;
                            }
                            .option-wrap{
                                background: #FFFFFF;
                                box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.07);
                                border-radius: 12px;
                                position: absolute;
                                top: 68px;
                                left: 0;
                                z-index: 13;
                                max-height: 440px;
                                overflow-x: hidden;
                                overflow-y: scroll;
                                .option-item{
                                    height: 80px;
                                    white-space: nowrap;
                                    font-size: 28px;
                                    font-weight: 400;
                                    color: #A1A1A1;
                                    padding:20px 45px;
                                    position: relative;
                                    &:after{
                                        content:'';
                                        position: absolute;
                                        bottom: 0;
                                        left: 50%;
                                        transform: translateX(-50%);
                                        width: 60%;
                                        height: 2px;
                                        background:#F6F6F6;
                                    }
                                }
                            }
                        }

                    }

                    .scroll-right {
                        width: calc(100% - 236px);
                        white-space: nowrap;
                        .form-title {
                            text-align: center;
                            width: 118px;
                            display: inline-block;
                            white-space: nowrap;
                            position: relative;
                            .down-icon{
                                width: 28px;
                                margin-left: 3px;
                                margin-top: 2px;
                            }
                            .option-wrap{
                                background: #FFFFFF;
                                box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.07);
                                border-radius: 12px;
                                position: absolute;
                                top: 68px;
                                z-index: 13;
                                .option-item{
                                    white-space: nowrap;
                                    font-size: 28px;
                                    font-weight: 400;
                                    color: #A1A1A1;
                                    padding:20px 45px;
                                    position: relative;
                                    &:after{
                                        content:'';
                                        position: absolute;
                                        bottom: 0;
                                        left: 50%;
                                        transform: translateX(-50%);
                                        width: 60%;
                                        height: 2px;
                                        background:#F6F6F6;
                                    }
                                }
                            }
                            .option-wrap-left{
                                right: 0 !important;
                            }
                            .option-wrap-right{
                                right: 0 !important;
                            }
                        }
                    }
                }
                .center-content{
                    border: 2px solid #F5F7F6;
                    border-top: 0;
                    border-bottom: 0;
                    width: 100%;
                    .box{
                        width: 670px;
                        height: 80px;
                        border-radius: 12px;
                        border: 2px solid #318544;
                        font-size: 24px;
                        font-weight: 400;
                        color: #318544;
                        line-height: 80px;
                        text-align: center;
                        margin: 16px auto;
                    }
                }
                .form-content {
                    width: 100%;
                    //height: 700px;
                    height: auto;
                    //max-height: 700px;
                    min-height: 80px;
                    border-radius: 16px 16px 0 0 ;
                    border: 2px solid #F5F7F6;
                    border-top: 0;
                    display: flex;
                    //overflow-y: scroll;
                    overflow-x: hidden;
                    flex-wrap: wrap;

                    .fixed-left {
                        width: 236px;
                        height: 100%;
                        position: relative;
                        z-index: 10;
                        //overflow-y: scroll;
                        .fixed-item-left {
                            width: 236px;
                            display: flex;
                            justify-content: center;
                            height: 90px;
                            align-items: center;

                            .form-title {
                                width: 50%;
                                text-align: center;
                                font-size: 28px;
                                color: rgba(0, 0, 0, 0.4);
                            }
                        }
                    }

                    .scroll-right {
                        width: calc(100% - 236px);
                        height: 100%;
                        //overflow-x: scroll;
                        //overflow-y: scroll;
                        white-space: nowrap;

                        .fixed-item-right {
                            width: 100%;
                            height: 90px;
                            line-height: 90px;

                            .form-title {
                                text-align: center;
                                width: 118px;
                                display: inline-block;
                                white-space: nowrap;
                                font-size: 28px;
                                color: rgba(0, 0, 0, 0.4);
                                .form-title-flex{
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    .edit-img{
                                        margin-left: 5px;
                                        width: 25px;
                                    }
                                }
                            }

                            .form-title-active{
                                color:#008C2F !important;
                            }
                        }
                        .tips{
                            font-size: 24px;
                            color:#a5a5a5;
                            height: 100%;
                            line-height: 80px;
                        }

                    }
                    .page-wrap{
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin:20px 0;
                        div{
                            width: 56px;
                            height: 56px;
                            border-radius: 4px;
                            border: 1px solid rgba(0,0,0,0.08);
                            font-size: 24px;
                            font-weight: 400;
                            color: #525F66;
                            margin: 0 8px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            &:last-child{
                                border: 0;
                            }
                            &:first-child{
                                border: 0;
                            }
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .num-page-active{
                            color: #2B447E;
                            border: 1px solid #008C2F;
                        }
                    }
                    .tips-other{
                        font-size: 24px;
                        color:#a5a5a5;
                        height:80px;
                        line-height: 80px;
                        width: 100%;
                        text-align: center;
                    }

                }
                .vant-pagination-wrap{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    margin:20px 0;
                    justify-content: center;
                }
                .swiper-change-wrap{
                    padding: 18px 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 24px;
                    font-weight: 400;
                    color: #008C2F;
                    border: 2px solid #F5F7F6;
                    border-top: 0;
                    border-radius:0 0 16px 16px ;
                    span{
                        margin: 0 15px;
                    }
                    img{
                        width: 24px;
                    }
                    .left-active{
                        transform: rotate(180deg);
                    }
                    .right-def{
                        transform: rotate(180deg);
                    }
                }
            }
            .case-data-wrap{
                margin-top: 15px;
                margin-bottom: 20px;
                width: 100%;
                background: #EDEFEE;
                border-radius: 16px;
                box-sizing: border-box;
                padding: 28px 20px;
                .case-data-item{
                    .case-all-num{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0 22px;
                        height: 100px;
                        width: 100%;
                        background: #FFFFFF;
                        border-radius: 16px;
                        margin-top: 24px;
                        .num-name{
                            font-size: 28px;
                            font-weight: 400;
                            color: #318544;
                        }
                        .num-text{
                            font-size: 48px;
                            font-weight: 500;
                            color: #00883B;
                        }
                    }
                    .module-wrap{
                        display: flex;
                        flex-wrap: wrap;
                        margin-top: 26px;
                        .module-item{
                            margin-right: 26px;
                            width: 208px;
                            height: 180px;
                            background: rgba(255,255,255,0.5);
                            border-radius: 16px;
                            margin-bottom: 26px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            &:nth-child(3n){
                                margin-right: 0;
                            }
                            .module-num{
                                font-size: 44px;
                                font-weight: 500;
                                color: rgba(0,0,0,0.7);
                            }
                            .module-name{
                                margin-top: 5px;
                                font-size: 24px;
                                font-weight: 400;
                                color: rgba(0,0,0,0.3);
                            }
                        }
                    }
                }
            }
        }
        //客户行为
        .customer-plat{
            .my-swipe-map{
                .van-swipe-item-one{
                    .form-tab-wrap{
                        .fixed-left{
                            width: 280px;
                            .form-title{
                                &:first-child{
                                    flex: 1;
                                }
                                &:last-child{
                                    width:120px;
                                }
                            }
                        }
                        .scroll-right{
                            width: calc(100%  - 280px);
                            .form-title{
                                &:nth-child(1){
                                    width: 420px;
                                }
                                &:nth-child(2){
                                    width: 150px;
                                }
                                &:nth-child(3){
                                    width: 150px;
                                }
                            }
                        }
                    }
                    .form-content{
                        .fixed-left{
                            width: 280px;
                            .fixed-item-left{
                                width: 280px;
                                .form-title{
                                    &:first-child{
                                        font-size: 24px;
                                        color: rgba(0,0,0,0.4);
                                        flex: 1;
                                    }
                                    &:last-child{
                                        width:120px;
                                        font-size: 24px;
                                        color: #222222;
                                    }
                                }
                            }
                        }
                        .scroll-right{
                            width: calc(100%  - 280px);
                            .form-title{
                                &:nth-child(1){
                                    width: 420px;
                                }
                                &:nth-child(2){
                                    width: 150px;
                                }
                                &:nth-child(3){
                                    width: 150px;
                                }
                            }
                        }
                    }
                }
                .van-swipe-item-two{
                    .form-tab-wrap{
                        .fixed-left{
                            width: 410px;
                            .form-title{
                                &:first-child{
                                    width:110px;
                                }
                                &:last-child{
                                    flex: 1;
                                }
                            }
                        }
                        .scroll-right{
                            width: calc(100%  - 410px);
                            .form-title{
                                width: 154px;
                            }
                        }
                    }
                    .form-content{
                        .fixed-left{
                            width: 410px;
                            .fixed-item-left{
                                width: 410px;
                                .form-title{
                                    &:first-child{
                                        font-size: 24px;
                                        color: #222222;
                                        width:110px;
                                    }
                                    &:last-child{
                                        flex: 1;
                                        font-size: 24px;
                                        color: rgba(0,0,0,0.4);
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                        .scroll-right{
                            width: calc(100%  - 410px);
                            .form-title{
                                width: 154px;
                            }
                        }
                    }
                }
            }
        }
        //分品类表单的宽度单独设置
        .category-plat{
            .my-swipe-map{
                .van-swipe-item-one{
                    .form-tab-wrap{
                        .fixed-left{
                            width: 410px;
                            .form-title{
                                &:first-child{
                                    width:164px;
                                }
                                &:last-child{
                                    flex: 1;
                                }
                            }
                        }
                        .scroll-right{
                            width: calc(100%  - 410px);
                            .form-title{
                                width: 154px;
                            }
                        }
                    }
                    .form-content{
                        .fixed-left{
                            width: 410px;
                            .fixed-item-left{
                                width: 410px;
                                .form-title{
                                    &:first-child{
                                        font-size: 24px;
                                        color: #222222;
                                        width:164px;
                                    }
                                    &:last-child{
                                        flex: 1;
                                        font-size: 24px;
                                        color: rgba(0,0,0,0.4);
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                        .scroll-right{
                            width: calc(100%  - 410px);
                            .form-title{
                                width: 154px;
                            }
                            .tips{
                                transform: translateX(-120px);
                            }
                        }
                    }
                }
                .van-swipe-item-two{
                    .form-tab-wrap{
                        .fixed-left{
                            width: 410px;
                            .form-title{
                                &:first-child{
                                    width:110px;
                                }
                                &:last-child{
                                    flex: 1;
                                }
                            }
                        }
                        .scroll-right{
                            width: calc(100%  - 410px);
                            .form-title{
                                width: 154px;
                            }
                        }
                    }
                    .form-content{
                        position: relative;
                        .a-link{
                            position:absolute;
                            width: 100%;
                            height: 100%;
                            top: 0;
                            left: 0;
                            z-index: 99;
                        }
                        .fixed-left{
                            width: 410px;
                            .fixed-item-left{
                                width: 410px;
                                .form-title{
                                    &:first-child{
                                        font-size: 24px;
                                        color: #222222;
                                        width:110px;
                                    }
                                    &:last-child{
                                        flex: 1;
                                        font-size: 24px;
                                        color: rgba(0,0,0,0.4);
                                        text-decoration: underline;
                                    }
                                }
                            }
                        }
                        .scroll-right{
                            width: calc(100%  - 410px);
                            .form-title{
                                width: 154px;
                            }
                            .tips{
                                transform: translateX(-120px);
                            }
                        }
                    }
                }
            }
            .center-tips{
                box-sizing: border-box;
                padding: 5px 0 0 18px;
                .one-wrap{
                    font-size: 24px;
                    font-weight: 400;
                    color: #9B9B9B;
                    .option-wrap{
                        display: flex;
                        align-items: center;
                        .order{
                            display: flex;
                            align-items: center;
                            position: relative;
                            span{
                                font-size: 24px;
                                font-weight: 400;
                                color: #9B9B9B;
                            }
                            img{
                                width: 20px;
                                height: 20px;
                                margin-left: 4px;
                            }
                            .option-wrap-order{
                                background: #FFFFFF;
                                box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.07);
                                border-radius: 12px;
                                position: absolute;
                                top: 48px;
                                z-index: 13;
                                max-height: 440px;
                                overflow-x: hidden;
                                overflow-y: scroll;
                                .option-item{
                                    height: 80px;
                                    white-space: nowrap;
                                    font-size: 28px;
                                    font-weight: 400;
                                    color: #A1A1A1;
                                    padding:20px 45px;
                                    position: relative;
                                    &:after{
                                        content:'';
                                        position: absolute;
                                        bottom: 0;
                                        left: 50%;
                                        transform: translateX(-50%);
                                        width: 60%;
                                        height: 2px;
                                        background:#F6F6F6;
                                    }
                                }
                            }
                            .option-wrap-center{
                                left: 50% !important;
                                transform: translateX(-50%);
                            }
                            .option-wrap-left{
                                left: 0 !important;
                            }
                            .option-wrap-right{
                                right: 0 !important;
                            }
                        }
                        .tips{
                            font-size: 24px;
                            font-weight: 400;
                            color: #9B9B9B;
                            margin-left: 14px;
                        }
                    }
                }
                .two-wrap{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .option-wrap{
                        display: flex;
                        align-items: center;
                        .order{
                            display: flex;
                            align-items: center;
                            position: relative;
                            span{
                                font-size: 24px;
                                font-weight: 400;
                                color: #9B9B9B;
                            }
                            img{
                                width: 20px;
                                height: 20px;
                                margin-left: 4px;
                            }
                            .option-wrap-order{
                                background: #FFFFFF;
                                box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.07);
                                border-radius: 12px;
                                position: absolute;
                                top: 48px;
                                z-index: 13;
                                max-height: 440px;
                                overflow-x: hidden;
                                overflow-y: scroll;
                                .option-item{
                                    height: 80px;
                                    white-space: nowrap;
                                    font-size: 28px;
                                    font-weight: 400;
                                    color: #A1A1A1;
                                    padding:20px 45px;
                                    position: relative;
                                    &:after{
                                        content:'';
                                        position: absolute;
                                        bottom: 0;
                                        left: 50%;
                                        transform: translateX(-50%);
                                        width: 60%;
                                        height: 2px;
                                        background:#F6F6F6;
                                    }
                                }
                            }
                            .option-wrap-center{
                                left: 50% !important;
                                transform: translateX(-50%);
                            }
                            .option-wrap-left{
                                left: 0 !important;
                            }
                            .option-wrap-right{
                                right: 0 !important;
                            }
                        }
                        .tips{
                            font-size: 24px;
                            font-weight: 400;
                            color: #9B9B9B;
                            margin-left: 14px;
                        }
                    }
                    .btn-wrap{
                        font-size: 24px;
                        font-weight: 400;
                        color: #008C2F;
                    }
                }
            }
        }
    }
}
.popup-wrap{
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    top: 0;
    left: 0;
    .popup-content{
        width: 480px;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%,-50%);
        background: #fff;
        border-radius: 15px;
        padding:20px 0px 0 0px;
        overflow: hidden;
        .title{
            color:#008C2F;
            font-size:32px;
            text-align: center;
        }
        .text-area{
            width: 90%;
            height: 180px;
            border: 1px solid rgba(0,0,0,0.07);
            margin: 20px auto 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            textarea{
                width: 90%;
                height: 90%;
            }
        }
        .btn{
            display: flex;
            width: 100%;
            .btn-item{
                flex: 1;
                height: 80px;
                text-align: center;
                line-height: 80px;
                font-size: 32px;
                color: rgba(0, 0, 0, 0.40);
                &:last-child{
                    background: #008C2F;
                    color: #fff;
                }
            }
        }
    }
}
</style>
